import React, { useState } from "react";
import { state } from "../../data/state";
import axios from "axios";
const AddInstaller = () => {
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    state: "",
    district: "",
    penCard: "",
    aadharCard: "",
    bankName: "",
    accountHolderName: "",
    accountNumber: "",
    IFSC_code: "",
  });

  const handleChangeInput = (e) => {
    console.log("working...");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //   console.log("formData: ", formData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/installer/insertInstaller`,
        formData
      );
      //   console.log(response);
      if (response.success === true) {
        alert(response?.data?.message);
        setFormData({
          name: "",
          contact: "",
          state: "",
          district: "",
          penCard: "",
          aadharCard: "",
          bankName: "",
          accountHolderName: "",
          accountNumber: "",
          IFSC_code: "",
        });
      } else {
        alert(response?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.log("Error : ", error);
      alert(error.response?.data?.message || "Something is wrong");
    }
  };

  return (
    <div className="w-auto flex flex-col">
      <div className="mainHeading">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
          A<span className="text-lg">DD</span>I
          <span className="text-lg">NSTALLER</span>
        </h1>
      </div>
      <div className="w-full h-full">
        <div className="formField">
          <form onSubmit={handleSubmit}>
            <div className="grid gap-3 m-6 md:grid-cols-4">
              <div>
                <label
                  htmlFor="name"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Name<span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  onChange={handleChangeInput}
                  value={formData?.name}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter Name"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="contact"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Contact<span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="number"
                  id="contact"
                  name="contact"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      handleChangeInput(e);
                    }
                  }}
                  value={formData?.contact}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter Number"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="state"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Select State<span className="text-red-500 fixed h-3">*</span>
                </label>
                <select
                  name="state"
                  onChange={handleChangeInput}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  {formData?.state === "" ? (
                    <option>Select State</option>
                  ) : (
                    <option disabled>Select State</option>
                  )}
                  {state?.map(({ name }, index) => (
                    <option key={index} value={name}>
                      {name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  htmlFor="district"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Select District
                  <span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="text"
                  id="district"
                  name="district"
                  onChange={handleChangeInput}
                  value={formData?.district}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter Your District"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="aadharCard"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Aadhar Card<span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="number"
                  id="aadharCard"
                  name="aadharCard"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,16}$/.test(value)) {
                      handleChangeInput(e);
                    }
                  }}
                  value={formData?.aadharCard}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter the Aadhar Card number"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="penCard"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Pen Card
                  <span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="text"
                  id="penCard"
                  name="penCard"
                  onChange={handleChangeInput}
                  value={formData?.penCard}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter the Pen card number"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="bankName"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Bank Name
                  <span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="text"
                  id="bankName"
                  name="bankName"
                  onChange={handleChangeInput}
                  value={formData?.bankName}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter Bank Name"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="accountHolderName"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Account Holder Name
                  <span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="text"
                  id="accountHolderName"
                  name="accountHolderName"
                  onChange={handleChangeInput}
                  value={formData?.accountHolderName}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter Account Holder Name"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="accountNumber"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  Account Number
                  <span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="number"
                  id="accountNumber"
                  name="accountNumber"
                  onChange={handleChangeInput}
                  value={formData?.accountNumber}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter Your Account Number "
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="IFSC_code"
                  className="block mb-2 text-sm font-medium text-gray-900 "
                >
                  IFSC Code
                  <span className="text-red-500 fixed h-3">*</span>
                </label>
                <input
                  type="text"
                  id="IFSC_code"
                  name="IFSC_code"
                  onChange={handleChangeInput}
                  value={formData?.IFSC_code}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 "
                  placeholder="Enter Account IFSC_code "
                  required
                />
              </div>

              <div
                style={{
                  display: "block",
                  flexDirection: "column",
                  alignItems: "center",
                  alignContent: "center",
                  height: 50,
                }}
              >
                <button
                  type="submit"
                  className="text-dark bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                >
                  Register
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddInstaller;
